module.exports = "/static/assets/7264c0b67b765f818b43510d45822a3f.png";